import { Controller } from '@hotwired/stimulus'
import { BACK_NAV_KEY } from './back_nav_controller'

// I-UXF-nav-1: the signed-out pages (layouts/auth: sign-in after Odhlásit or an expired session) drop the Zpět trail,
// whose page titles name customers.
export default class BackNavResetController extends Controller {
  override connect(): void {
    try {
      sessionStorage.removeItem(BACK_NAV_KEY)
    } catch {
      // storage disabled: nothing stored
    }
  }
}
